const STORAGE_KEY = 'guest-user-id'

export function readGuestUserId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function storeGuestUserId(id: string): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, id)
  } catch {
    // ignore storage errors (private mode, etc.)
  }
}

export function clearGuestUserId(): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

